import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { Dialog, DialogContent } from '@material-ui/core';
import DialogTitle from './dialogComponents/dialogTitle.styled';
import DialogActions from './dialogComponents/dialogActions.styled';
import SolidButton from './solidBtn';

function ApplyStandAloneAudienceDialog({ isOpen, close }) {
  const history = useHistory();
  const location = useLocation();
  const {
    draft: draftId,
    audienceId,
    campaignId: campaignIdFromQuery,
  } = queryString.parse(location.search);

  // Extract campaignId from URL path (primary source for automated campaigns)
  // URL format: /dashboard/automation/edit/${campaignId}
  const campaignIdFromPath = location.pathname.match(
    /\/dashboard\/automation\/edit\/([^/]+)/
  )?.[1];
  // Path takes precedence since that's where campaignId is in automated campaigns flow
  const campaignId = campaignIdFromPath || campaignIdFromQuery;

  const handleApplyDialog = () => {
    const params = new URLSearchParams();
    params.set('apply', '1');
    params.set('tab', 'audiences');

    if (draftId) {
      params.set('draft', draftId);
    } else if (audienceId) {
      params.set('audienceId', audienceId);
    }

    // Preserve campaignId for automated campaigns context
    if (campaignId) {
      params.set('campaignId', campaignId);
    }

    history.push(`/dashboard/drafts?${params.toString()}`);
  };

  const closeDialogBox = () => {
    close();
  };

  return (
    <>
      <Dialog open={isOpen} onClose={closeDialogBox}>
        <DialogTitle>Applying a Standalone Audience</DialogTitle>
        <DialogContent>
          <p style={{ paddingTop: '20px' }}>
            Applying a standalone audience will overwrite your current audience.
          </p>
        </DialogContent>
        <DialogActions>
          <SolidButton onClick={closeDialogBox} color="grey">
            Cancel
          </SolidButton>
          <SolidButton onClick={handleApplyDialog}>Ok</SolidButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ApplyStandAloneAudienceDialog;
